var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newMessage clearfix"},[_c('span',[_vm._v("最新留言：")]),_vm._v(" "),_c('van-notice-bar',{attrs:{"mode":"","scrollable":true}},[_vm._v("\n      "+_vm._s(_vm.msgs)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-674d1f1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewMessage/NewMessage.vue
// module id = null
// module chunks = 